import {useNavigate} from 'react-router-dom';
import {useEffect} from 'react';

import type {SidebarSection} from 'modules/decisionsNext/hooks/sidebar/types';

import {useSidebarSections} from 'modules/decisionsNext/hooks/sidebar/useSidebarSections';
import {withUrlIcons} from 'modules/decisionsNext/hooks/sidebar';
import {updateWebViewEvents, isWebViewApp, updateWebViewSidebar} from 'core/utils/webView';

export const useInitializeWebViewApp = () => {
  const navigate = useNavigate();
  const {home, sections} = useSidebarSections();

  if (!isWebViewApp()) {
    return;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks -- it's either webview or not
  useEffect(() => {
    updateWebViewSidebar(
      withUrlIcons(
        [
          home && {
            items: [home],
          },
          ...sections,
        ].filter(Boolean)
      ) as SidebarSection[]
    );
  }, [home, sections]);

  // eslint-disable-next-line react-hooks/rules-of-hooks -- it's either webview or not
  useEffect(() => {
    updateWebViewEvents({
      navigate,
    });
  }, [navigate]);
};
